export const STUDIO_DRAWER_SEARCH_PARAM = 'studio' as const;
